import React, { useMemo, useEffect } from "react";
import CustomSelect from "../CustomSelect";
import { useTranslation } from "../../hooks/useTranslation";
import { useSelector } from "react-redux";

const getBrandName = (brand, lang, preview = false) => {
    const translation = brand?.translations?.find(t => t.languageIsoCode === lang);
    if (preview) {
        const limit = 10;
        const name = translation ? translation?.brandName : brand?.brandName;
        return name?.length > limit ? name?.slice(0, limit) + "..." : name;
    }
    return translation ? translation?.brandName : brand?.brandName;
};

const BrandFilter = ({ brands, chainBrand, selectedValue, setSelected, lang, setSelectedName }) => {
    const { t } = useTranslation();
    const chain = useSelector((state) => state.chain);

    const optionsWithAll = useMemo(() => [
        { ...chainBrand, value: "brand-all", label: t("AllBrands") },
        ...brands.filter(b => b.brandId != chainBrand?.brandId).map(b => ({ ...b, label: getBrandName(b, lang), value: `brand-${b.brandId}` }))
    ], [brands, lang, chain]);

    useEffect(() => {
        let selectedId = selectedValue?.replace("brand-", "");
        let brand = brands?.find(b => b.brandId == selectedId);
        setSelectedName(getBrandName(brand, lang, true));
    }, [selectedValue]);

    return (
        <div className="filter-section">
            <CustomSelect
                options={optionsWithAll}
                onChange={setSelected}
                selectedValue={selectedValue}
                fieldName="filterBrand"
                id="filter-brand"
                placeholder={t("AllBrands")}
                label={t("AllBrands")}
                className="products-filter"
                classNameButton="dropdown-toggle btn btn-primary"
                classNameList="dropdown-menu show"
                renderOption={(item) => (
                    <>
                        <span>{ item.label }</span>
                        {item.brandLogoUrl && <img src={item.brandLogoUrl} alt={getBrandName(item, lang)} />}
                    </>
                )}
            />
        </div>
    );
};

export default BrandFilter;
